<template>
  <a-breadcrumb style="margin: 16px 0">
    <a-breadcrumb-item>SIG&Committer</a-breadcrumb-item>
    <a-breadcrumb-item>Committer 贡献看板</a-breadcrumb-item>
  </a-breadcrumb>

  <div class="page">
    <section class="section">
      <div style="display: flex; justify-content: space-between;">
        <div class="section-title">
          <span style="font-size: 18px; color: #155DFC">
            <team-outlined />
          </span>
          Committer 贡献看板
        </div>
        <a-radio-group v-model:value="activeTab">
          <a-radio-button value="detail">详情</a-radio-button>
          <a-radio-button value="summary">汇总</a-radio-button>
        </a-radio-group>
      </div>
      <div class="table-wrapper">
        <committer-stat-detail-table
          v-if="activeTab === 'detail'"
          :records="records"
          :loading="loading"
          :page-vo="pageVo"
          @page-change="handlePageChange"
          @page-size-change="handlePageSizeChange"
        />
        <committer-stat-summary-table
          v-else
          :records="records"
          :loading="loading"
          :page-vo="pageVo"
          @page-change="handlePageChange"
          @page-size-change="handlePageSizeChange"
        />
      </div>
    </section>
  </div>
</template>

<script setup>
import { TeamOutlined } from '@ant-design/icons-vue';
import { onMounted, reactive, ref } from 'vue';
import axios from 'axios';

import CommitterStatDetailTable from './CommitterStatDetailTable.vue';
import CommitterStatSummaryTable from './CommitterStatSummaryTable.vue';

const activeTab = ref('detail');
const loading = ref(false);
const records = ref([]);

const pageVo = reactive({
  totalRows: 0,
  curPage: 1,
  pageSize: 10,
  startIndex: 0,
  endIndex: 0,
  totalPages: 0,
});

const fetchData = async (curPage = 1, pageSize = pageVo.pageSize) => {
  loading.value = true;
  try {
    const res = await axios.get('/metric/getCommitterContributionStat', {
      params: { curPage, pageSize },
    });
    const baseResult = res.data?.baseResult;
    const page = res.data?.pageVO;

    records.value = baseResult?.status === 'S' && Array.isArray(baseResult.data)
      ? baseResult.data
      : [];

    if (page) {
      pageVo.totalRows = page.totalRows ?? pageVo.totalRows;
      pageVo.curPage = page.curPage ?? pageVo.curPage;
      pageVo.pageSize = page.pageSize ?? pageVo.pageSize;
      pageVo.startIndex = page.startIndex ?? 0;
      pageVo.endIndex = page.endIndex ?? 0;
      pageVo.totalPages = page.totalPages ?? pageVo.totalPages;
    }
  } catch (error) {
    records.value = [];
    console.error('fetch committer stat error', error);
  } finally {
    loading.value = false;
  }
};

const handlePageChange = (page) => {
  fetchData(page, pageVo.pageSize);
};

const handlePageSizeChange = (_current, size) => {
  pageVo.pageSize = size;
  pageVo.curPage = 1;
  fetchData(1, size);
};

onMounted(() => {
  fetchData(pageVo.curPage, pageVo.pageSize);
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 16px;
}

.section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 18px 22px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  gap: 8px;
  color: #0f172a;
}

.table-wrapper {
  margin: 16px;
}
</style>